import React from 'react';
import TablesPage from './components/TablesPage.jsx';
import BackToTopButton from './components/BackToTopButton/BackToTopButton.jsx'
import "./styles/reset.css"
import "./styles/global.css"

function App() {
  return (
    <div className="App">
      <BackToTopButton />
      <TablesPage />
    </div>
  );
}

export default App;